// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@page {
    size: A4;
    margin: 40px 40px 40px 40px;
    /* TOP RIGHT BOTTOM LEFT */
}

body {
    font-family: 'Noto Sans Devanagari', sans-serif;
    font-size: 15px;
    line-height: 1.6;
    margin: 0;
    /* IMPORTANT */
}

.page {
    width: 100%;
    padding: 0 40px;
    /* THIS CREATES LEFT + RIGHT SPACE */
    box-sizing: border-box;
}

p {
    margin: 0;
    text-align: justify;
    word-break: break-word;
}

.center p {
    text-align: center !important;
}

.right {
    text-align: right;
}

.header {
    display: flex;
    justify-content: space-between;
    gap: 20px;
}

.header p {
    width: 48%;
}

.indent {
    margin-left: 30px;
}

.pdf-table {
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
}

.pdf-table th,
.pdf-table td {
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word;
    /* important for long strings */
    white-space: normal;
    /* allow wrapping */
    vertical-align: top;
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/ProjectManagement/GrDraftList.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;IACR,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,+BAA+B;IAC/B,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":["@page {\r\n    size: A4;\r\n    margin: 40px 40px 40px 40px;\r\n    /* TOP RIGHT BOTTOM LEFT */\r\n}\r\n\r\nbody {\r\n    font-family: 'Noto Sans Devanagari', sans-serif;\r\n    font-size: 15px;\r\n    line-height: 1.6;\r\n    margin: 0;\r\n    /* IMPORTANT */\r\n}\r\n\r\n.page {\r\n    width: 100%;\r\n    padding: 0 40px;\r\n    /* THIS CREATES LEFT + RIGHT SPACE */\r\n    box-sizing: border-box;\r\n}\r\n\r\np {\r\n    margin: 0;\r\n    text-align: justify;\r\n    word-break: break-word;\r\n}\r\n\r\n.center p {\r\n    text-align: center !important;\r\n}\r\n\r\n.right {\r\n    text-align: right;\r\n}\r\n\r\n.header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: 20px;\r\n}\r\n\r\n.header p {\r\n    width: 48%;\r\n}\r\n\r\n.indent {\r\n    margin-left: 30px;\r\n}\r\n\r\n.pdf-table {\r\n    table-layout: fixed;\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.pdf-table th,\r\n.pdf-table td {\r\n    word-wrap: break-word;\r\n    overflow-wrap: break-word;\r\n    word-break: break-word;\r\n    /* important for long strings */\r\n    white-space: normal;\r\n    /* allow wrapping */\r\n    vertical-align: top;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
